/** Cookie name — must stay in sync with inline bootstrap in pages/+Head.tsx */
export const JC_CONSENT_COOKIE_NAME = 'jc_consent_v1';

export const JC_CONSENT_SCHEMA_VERSION = 1 as const;

/** ~180 days */
export const JC_CONSENT_MAX_AGE_SECONDS = 180 * 24 * 60 * 60;

/** Dispatched on document when user should open cookie preferences (e.g. from Footer). */
export const JC_COOKIE_CONSENT_OPEN_EVENT = 'jc:cookie-consent-open';

/**
 * Dispatched on document right after analytics consent is granted via the vanilla-JS fallback
 * path in CookieConsentBanner.tsx (island routes — SRP, job detail, etc. — never hydrate that
 * component, so its React onClick handler, which calls runAnalyticsConsentBootstrap() directly,
 * never runs there). Without this event, gtag is never bootstrapped on the very page where
 * consent was just granted: the fallback script only writes the cookie. pages/+client.ts listens
 * for this to call runAnalyticsConsentBootstrap() there too, and to retry any pending
 * account_created/sign_in_complete signal now that gtag actually exists.
 */
export const JC_ANALYTICS_CONSENT_GRANTED_EVENT = 'jc:analytics-consent-granted';

/**
 * Dispatched on document when the visitor rejects analytics via the vanilla-JS fallback path in
 * CookieConsentBanner.tsx (the counterpart of JC_ANALYTICS_CONSENT_GRANTED_EVENT). The React
 * banner discards the pre-consent event queue directly; island routes never hydrate it, so
 * pending-product-events.ts listens for this to do the same. Without it, a visitor who rejected
 * and then accepted later on the same page load would have the earlier events flushed.
 */
export const JC_ANALYTICS_CONSENT_REJECTED_EVENT = 'jc:analytics-consent-rejected';
